module.exports = __webpack_public_path__ + "static/media/titleLogo.4c9de186.png";